import { Card, Row, Col, Typography, Divider, Button, Space, Collapse, Spin, List, Modal, message } from "antd";
import { ScheduleOutlined, TagsOutlined, CopyOutlined, TableOutlined, WalletOutlined, EditOutlined, EyeOutlined, DownloadOutlined, DeleteOutlined, ExclamationCircleOutlined, RightOutlined, DollarOutlined, UserOutlined } from "@ant-design/icons";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import "../../../assets/dist/ConsumerProject/Consumer/ConsumerPreview.css"
import { useEffect, useState } from "react";
import _consumerService from "../../../modules/consumerService";
import ReviewCommentByApplicationIdAndSection from "../Administrator/ReviewCommentByApplicationIdAndSection";
import { useHistory } from "react-router-dom";
import { routes } from "../../../routes/Routes";
import moment from "moment";
import _commonService from "../../../modules/commonService";
import { COMMON_ERROR_MSG, RECORD_DELETED_MSG } from "../../../constants/constants";
import { ScreenNameDashboard } from "../../../constants/DataConstants";
import BalanceSheetQuestionnaireConsumerDashboard from "./BalanceSheetQuestionnaireConsumerDashboard";

const { Title, Text } = Typography;
const { confirm } = Modal;

const FinancialStatementTabForConsumer = ({ activeKey }) => {
  const [incomeSourceDetails, setIncomeSourceDetails] = useState({});
  const [expensesDetails, setExpensesDetails] = useState({});
  const [cashShortTermInvestmentDetails, setCashShortTermInvestmentDetails] = useState([]);
  const ApplicationObjId = localStorage.getItem("ApplicationObjId");
  const [dataLoadedCashShortTerm, setDataLoadedCashShortTerm] = useState(false);
  const [dataLoadedStockAndBond, setDataLoadedStockAndBond] = useState(false);
  const [dataLoadedCashValue, setDataLoadedCashValue] = useState(false);
  const [dataLoadedunListedStocks, setDataLoadedunListedStocks] = useState(false);
  const [dataLoadedEquityIntrestBusiness, setDataLoadedEquityIntrestBusiness] = useState(false);
  const [dataLoadedAccountNotesReceivable, setDataLoadedAccountNotesReceivable] = useState(false);
  const [dataLoadedownPersonalResidence, setDataLoadedownPersonalResidence] = useState(false);
  const [dataLoadedVestedIntrestPension, setDataLoadedVestedIntrestPension] = useState(false);
  const [dataLoadedreInvestment, setDataLoadedreInvestment] = useState(false);
  const [dataLoadedLimitedPartenership, setDataLoadedLimitedPartenership] = useState(false);
  const [dataLoadednotesPayableBankSecured, setDataLoadednotesPayableBankSecured] = useState(false);
  const [dataLoadednotesPayableBankUnSecured, setDataLoadednotesPayableBankUnSecured] = useState(false);
  const [dataLoadednotesPayableOther, setDataLoadednotesPayableOther] = useState(false);
  const [dataLoadedAccountPayable, setDataLoadedAccountPayable] = useState(false);
  const [dataLoadedcreditCardBalance, setDataLoadedcreditCardBalance] = useState(false);
  const [dataLoadedMortgagesDueWithInOne, setDataLoadedMortgagesDueWithInOne] = useState(false);
  const [dataLoadedMortgagesDueBeyond, setDataLoadedMortgagesDueBeyond] = useState(false);
  const [listedStockAndBondsDetails, setListedStockAndBondsDetails] = useState([]);
  const [accountsandNotesReceivableDetails, setccountsandNotesReceivableDetails] = useState([]);
  const [cashValueLifeInsuranceDetails, setCashValueLifeInsurance] = useState([]);
  const [financialStatementDataDetails, setfinancialStatementData] = useState([]);
  const [ownPersonalResidenceDetails, setOwnPersonalResidenceDetails] = useState([]);
  const [vestedIntrestPensionDetails, setVestedIntrestPensionDetails] = useState([]);
  const [unListedStocksDetails, setunListedStocksDetails] = useState([]);
  const [equityIntrestBusinessDetails, setEquityIntrestBusinessDetails] = useState([]);
  const [reInvestmentDetails, setreInvestmentDetails] = useState([]);
  const [generalAndLimitedPartenershipDetails, setGeneralAndLimitedPartenershipDetails] = useState([]);
  const [notesPayableBankSecuredDetails, setNotesPayableBankSecuredDetails] = useState([]);
  const [notesPayableBankUnSecuredDetails, setNotesPayableBankUnSecuredDetails] = useState([]);
  const [accountPayableDetails, setAccountPayableDetails] = useState([]);
  const [notesPayableOtherDetails, setNotesPayableOtherDetails] = useState([]);
  const [creditCardBalanceDetails, setCreditCardBalanceDetails] = useState([]);
  const [mortgagesDueWithInOneDetails, setMortgagesDueWithInOneDetails] = useState([]);
  const [mortgagesDueBeyondOneDetails, setMortgagesDueBeyondOneDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedDocUrl, setSelectedDocUrl] = useState('');
  const [selectedDocName, setSelectedDocName] = useState('');

  const history = useHistory();

  useEffect(() => {
    if (activeKey && activeKey == "4") {
      getIncomeSourceDetailsByID();
      getExpensesDetailsByID();
      getFinancialStatementData();
    }
  }, [activeKey]);

  const getIncomeSourceDetailsByID = async () => {
    try {
      setLoading(true);
      const res = await _consumerService.getIncomeSourceByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setIncomeSourceDetails(resObj[0]);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  const getExpensesDetailsByID = async () => {
    try {
      setLoading(true);
      const res = await _consumerService.getExpensesByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setExpensesDetails(resObj[0]);

      }
    } catch (e) {
      console.log(e);

    } finally {
      setLoading(false);
    }
  };
  const getCashShortTermInvestmentDetailsByID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getCashShortTermInvestmentsByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setCashShortTermInvestmentDetails(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);

    } finally {
      setLoading(false);
    }
  };
  const getListedStockAndBondsDetailsByID = async () => {
    setLoading(true);

    try {
      const res = await _consumerService.getStockBondGovSecurityByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setListedStockAndBondsDetails(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);

    } finally {
      setLoading(false);
    }
  };
  const getFinancialStatementData = async () => {
    try {
      setLoading(true);
      const res = await _consumerService.getFinancialStatementData(ApplicationObjId, ScreenNameDashboard);
      if (res.data) {
        let resObj = res?.data.Obj;
        setfinancialStatementData(resObj);

      }
    } catch (err) {

      console.error("Error fetching assets", err);
    } finally {
      setLoading(false);
    }
  };

  const getAccountsAndNotesReceivableDetailsByID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getAccountNoteReceivableByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setccountsandNotesReceivableDetails(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);

    } finally {
      setLoading(false);
    }
  };
  const getCashValueLifeInsuranceDetailsByID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getCashValueLifeInsuranceByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setCashValueLifeInsurance(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);

    } finally {
      setLoading(false);
    }
  };
  const getOwnPersonalResidenceDetailsByID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getOwnPersonalResidenceByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setOwnPersonalResidenceDetails(resObj);


      }
    } catch (err) {
      console.error("Error fetching assets", err);

    } finally {
      setLoading(false);
    }
  };
  const getVestedIntrestPensionDetailsByID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getVestedIntrestPensionByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setVestedIntrestPensionDetails(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);

    } finally {
      setLoading(false);
    }
  };
  const getUnListedStocksDetailsByID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getUnListedStocksByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setunListedStocksDetails(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);

    } finally {
      setLoading(false);
    }
  };
   const getEquityInterestInBusinessByApplicationID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getEquityInterestInBusinessByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setEquityIntrestBusinessDetails(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);

    } finally {
      setLoading(false);
    }
  };
  const getReInvestmentDetailsByID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getInvestmentByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setreInvestmentDetails(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);

    } finally {
      setLoading(false);
    }
  };
  const getGeneralAndLimitedPartenershipDetailsByID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getGeneralAndLimitedPartenershipByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setGeneralAndLimitedPartenershipDetails(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);

    } finally {
      setLoading(false);
    }
  };
  const getNotesPayableBankSecuredDetailsByID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getNotesPayableBankSecuredByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setNotesPayableBankSecuredDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);

    } finally {
      setLoading(false);
    }
  };
  const getNotesPayableBankUnSecuredDetailsByID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getNotesPayableBankUnSecuredByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setNotesPayableBankUnSecuredDetails(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);

    } finally {
      setLoading(false);
    }
  };
  const getAccountsPayableDetailsByID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getAccountsPayableByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setAccountPayableDetails(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);

    } finally {
      setLoading(false);
    }
  };

  const getNotesPayableOtherDetailsByID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getNotesPayableOtherByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setNotesPayableOtherDetails(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);

    } finally {
      setLoading(false);
    }
  };
  const getCreditCardBalanceDetailsByID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getCreditCardBalanceByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setCreditCardBalanceDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);

    } finally {
      setLoading(false);
    }
  };
  const getMortagagesDueWithInOneDetailsByID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getMortgageDueWithinByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setMortgagesDueWithInOneDetails(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);

    } finally {
      setLoading(false);
    }
  };
  const getMortagagesDueBeyondOneDetailsByID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getMortgageDueBeyondByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setMortgagesDueBeyondOneDetails(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);

    } finally {
      setLoading(false);
    }
  };

 const onIncomeSourcesEditClick = () => {
    // history.push({
    //   pathname: routes.incomeSources.path,
    //   state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey },
    // });

    history.push({ pathname: routes.incomeSourcesForConsumer.path, state: { isFromDashboard: false } });
  }
  const onExpensesEditClick = () => {
    // history.push({
    //   pathname: routes.expenses.path,
    //   state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey },
    // });

    history.push({ pathname: routes.expensesForConsumer.path, state: { isFromDashboard: false } });
  }
  const onBalanceSheetAssetsEditClick = () => {
    // history.push({
    //   pathname: routes.balanceSheetAssets.path,
    //   state: { applicationObjId: ApplicationObjId, isFromDashboard: true, activeKey },
    // });

    history.push({ pathname: routes.balanceSheetAssetsForConsumer.path, state: { isFromDashboard: false } });

  }

  const onBalanceSheetTotalAssetsEditClick = () => {
    // history.push({
    //   pathname: routes.balanceSheetTotalAssets.path,
    //   state: { applicationObjId: ApplicationObjId, isFromDashboard: true, activeKey },
    // });
    history.push({ pathname: routes.balanceSheetTotalAssetsForConsumer.path, state: { isFromDashboard: false } });


  }

  const onBalanceSheetTotalLiabilitiesAssetsEditClick = () => {
    // history.push({
    //   pathname: routes.balanceSheetTotalLiabilities.path,
    //   state: { applicationObjId: ApplicationObjId, isFromDashboard: true, activeKey },
    // });
    history.push({ pathname: routes.balanceSheetTotalLiabilitiesForConsumer.path, state: { isFromDashboard: false } });

  }
  const handleCollapseCashShortTermInvestmentChange = (key) => {
    if (key === "1" && !dataLoadedCashShortTerm) {
      getCashShortTermInvestmentDetailsByID();
      setDataLoadedCashShortTerm(true);
    }
  }
  const handleCollapseListedStockAndBondChange = (key) => {
    if (key === "2" && !dataLoadedStockAndBond) {
      getListedStockAndBondsDetailsByID();
      setDataLoadedStockAndBond(true);
    }
  }
  const handleCollapseChangeAccountNotesReceivable = (key) => {
    if (key === "3" && !dataLoadedAccountNotesReceivable) {
      getAccountsAndNotesReceivableDetailsByID();
      setDataLoadedAccountNotesReceivable(true);
    }
  }
  const handleCollapseCashValueLifeInsurance = (key) => {
    if (key === "4" && !dataLoadedCashValue) {
      getCashValueLifeInsuranceDetailsByID();
      setDataLoadedCashValue(true);
    }
  }

  const handleCollapseOwnPersonalResidence = (key) => {
    if (key === "5" && !dataLoadedownPersonalResidence) {
      getOwnPersonalResidenceDetailsByID();
      setDataLoadedownPersonalResidence(true);
    }
  }
  const handleCollapseestedIntrestPension = (key) => {
    if (key === "6" && !dataLoadedVestedIntrestPension) {
      getVestedIntrestPensionDetailsByID();
      setDataLoadedVestedIntrestPension(true);
    }
  }
  const handleCollapUnListedStocks = (key) => {
    if (key === "7" && !dataLoadedunListedStocks) {
      getUnListedStocksDetailsByID();
      setDataLoadedunListedStocks(true);
    }
  }
   const handleCollapeEquityInterestBusiness = (key) => {
    if (key === "99" && !dataLoadedEquityIntrestBusiness) {
      getEquityInterestInBusinessByApplicationID();
      setDataLoadedEquityIntrestBusiness(true);
    }
  }

  const handleCollapReInvestment = (key) => {
    if (key === "8" && !dataLoadedreInvestment) {
      getReInvestmentDetailsByID();
      setDataLoadedreInvestment(true);
    }
  }
  const handleCollapgeneralAndLimitedPartenership = (key) => {
    if (key === "9" && !dataLoadedLimitedPartenership) {
      getGeneralAndLimitedPartenershipDetailsByID();
      setDataLoadedLimitedPartenership(true);
    }
  }
  const handleCollapseNotesPayableBankSecured = (key) => {
    if (key === "10" && !dataLoadednotesPayableBankSecured) {
      getNotesPayableBankSecuredDetailsByID();
      setDataLoadednotesPayableBankSecured(true);
    }
  }
  const handleCollapseNotesPayableBankUnSecured = (key) => {
    if (key === "11" && !dataLoadednotesPayableBankUnSecured) {
      getNotesPayableBankUnSecuredDetailsByID();
      setDataLoadednotesPayableBankUnSecured(true);
    }
  }
  const handleCollapseAccountsPayableChange = (key) => {
    if (key === "12" && !dataLoadedAccountPayable) {
      getAccountsPayableDetailsByID();
      setDataLoadedAccountPayable(true);
    }
  }
  const handleCollapseChangeNotesPayableOther = (key) => {
    if (key === "13" && !dataLoadednotesPayableOther) {
      getNotesPayableOtherDetailsByID();
      setDataLoadednotesPayableOther(true);
    }
  }

  const handleCollapseChangeCreditCardsBalance = (key) => {
    if (key === "14" && !dataLoadedcreditCardBalance) {
      getCreditCardBalanceDetailsByID();
      setDataLoadedcreditCardBalance(true);
    }
  }
  const handleCollapseChangeMortagagesDueWihtinOne = (key) => {
    if (key === "15" && !dataLoadedMortgagesDueWithInOne) {
      getMortagagesDueWithInOneDetailsByID();
      setDataLoadedMortgagesDueWithInOne(true);
    }
  }
  const handleCollapseChangeMortagagesDueBeyondOne = (key) => {
    if (key === "16" && !dataLoadedMortgagesDueBeyond) {
      getMortagagesDueBeyondOneDetailsByID();
      setDataLoadedMortgagesDueBeyond(true);
    }
  }

  const onDocumentEyeClick = ({ name, url }) => {
    setSelectedDocName(name);
    setSelectedDocUrl(url);
    setIsModalVisible(true);
  };


  const onDocumentDownloadClick = (docName, url) => {
    if (!url) {
      message.error("File URL not found.");
      return;
    }

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", docName || "document");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const deleteDocument = (item) => {
    if (!item.ownId || !item.name) {
      console.error("Missing name or ownId:", item);
      return;
    }

    Modal.confirm({
      title: `Are you sure you want to delete this ${item.name}?`,
      icon: <ExclamationCircleOutlined />,
      okText: <span id="yesBtn">Yes</span>,
      cancelText: <span id="noBtn">No</span>,
      okType: "primary",
      onOk() {
        deleteDocumentBySection(item.name, item.ownId);
      }
    });
  };

  const deleteDocumentBySection = async (item, ownId) => {
    console.log("item", item);
    setLoading(true);

    const sectionMap = {
      "Own Personal Residence": {
        section: "ApplicantOwnPersonalResidence",
        refetch: getOwnPersonalResidenceDetailsByID,
      },
      "General And Limited Partnership Interest": {
        section: "ApplicantGeneralAndLimitedPartenershipIntrest",
        refetch: getGeneralAndLimitedPartenershipDetailsByID,
      },
      "Mortgage Due Beyond": {
        section: "ApplicantMortgageDueBeyond",
        refetch: getMortagagesDueBeyondOneDetailsByID,
      },
      "Mortgage Due Within": {
        section: "ApplicantMortgageDueWithin",
        refetch: getMortagagesDueWithInOneDetailsByID,
      },
    };

    const selected = sectionMap[item];

    if (!selected) {
      console.error("Unknown section for item:", item);
      message.error("Invalid section selected.");
      setLoading(false);
      return;
    }

    try {
      const res = await _consumerService.deleteDocumentByDocumentId(ownId, selected.section);
      if (res?.data?.IsSuccess) {
        message.success(res.data.Message || RECORD_DELETED_MSG);
        selected.refetch?.();
      } else {
        message.error(res?.data?.Message || COMMON_ERROR_MSG);
      }
    } catch (error) {
      console.error("Delete failed:", error);
      message.error(COMMON_ERROR_MSG);
    } finally {
      setLoading(false);
    }
  };


  return (
    <Spin spinning={loading}>

      <Card
        title={
          <Row justify="space-between" align="middle">
            <Title className="initial-typography">
              <DollarOutlined />
              <span style={{ marginLeft: 8 }} >Income Sources</span>
            </Title>

            <EditOutlined onClick={onIncomeSourcesEditClick} />
          </Row>
        }

        className="mb10 mr5"
      >
        <div className="alignment-padding">
          <Row gutter={[16, 16]}>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col><Text type="secondary">Category</Text></Col>
                <Col><Text type="secondary">Value</Text></Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography"><Text type="secondary" >Salary (Gross)</Text></Col>
                <Col className="subtital-typography">{incomeSourceDetails?.GrossSalary ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.GrossSalary)}` : "N/A"}</Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography"><Text type="secondary">Bonus and Commissions</Text></Col>
                <Col className="subtital-typography">{incomeSourceDetails && incomeSourceDetails.BonusCommission ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.BonusCommission)}` : "N/A"}</Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography"><Text type="secondary">Dividends</Text></Col>
                <Col className="subtital-typography">
                  {incomeSourceDetails?.Devidend
                    ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.Devidend)}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography"><Text type="secondary">Interest</Text></Col>
                <Col className="subtital-typography">
                  {incomeSourceDetails?.Interest
                    ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.Interest)}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography"><Text type="secondary">Rental Income (Net)</Text></Col>
                <Col className="subtital-typography">
                  {incomeSourceDetails?.RentalIncome
                    ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.RentalIncome)}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography"><Text type="secondary">General Limited Partnership Income (Net)</Text></Col>
                <Col className="subtital-typography">
                  {incomeSourceDetails?.GenLimitedPartnershipIncome
                    ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.GenLimitedPartnershipIncome)}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography"><Text type="secondary">Trust Income</Text></Col>
                <Col className="subtital-typography">
                  {incomeSourceDetails?.TrustIncome
                    ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.TrustIncome)}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography"><Text type="secondary">Pension Income</Text></Col>
                <Col className="subtital-typography">
                  {incomeSourceDetails?.PensionIncome
                    ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.PensionIncome)}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography"><Text type="secondary">Other Income</Text></Col>
                <Col className="subtital-typography">
                  {incomeSourceDetails?.OtherIncome
                    ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.OtherIncome)}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col><Text type="secondary">Total Income</Text></Col>
                <Col>
                  {incomeSourceDetails?.IncomeSourceTotal
                    ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.IncomeSourceTotal)}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        {/* <ReviewCommentByApplicationIdAndSection  CommentSectionName="incomesource" /> */}
      </Card>

      <Card
        title={
          <Row justify="space-between" align="middle">
            <Title className="initial-typography">
              <TableOutlined />
              <span style={{ marginLeft: 8 }}>Expenses</span>
            </Title>

            <EditOutlined onClick={onExpensesEditClick} />
          </Row>
        }
        className="mb10 mr5"
      >
        <div className="alignment-padding">
          <Row gutter={[16, 16]}>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col><Text type="secondary">Category</Text></Col>
                <Col><Text type="secondary">Value</Text></Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography"><Text type="secondary">Mortgage or Rental Payments (P&I)</Text></Col>
                <Col className="subtital-typography">{expensesDetails && expensesDetails.MortgageOrRentalPayment ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.MortgageOrRentalPayment)}` : "N/A"}</Col>
              </Row>
            </Col>


            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Loan Payments (Excluding Mortgages)</Text>
                </Col>
                <Col className="subtital-typography">
                  {expensesDetails?.LoanPayment
                    ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.LoanPayment)}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>

            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Property Taxes/Assessments</Text>
                </Col>
                <Col className="subtital-typography">
                  {expensesDetails?.PropertyTax
                    ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.PropertyTax)}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>

            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Taxes (City, State, Federal)</Text>
                </Col>
                <Col className="subtital-typography">
                  {expensesDetails?.Taxes
                    ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.Taxes)}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>


            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Insurance Premiums</Text>
                </Col>
                <Col className="subtital-typography">
                  {expensesDetails?.InsurancePremium
                    ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.InsurancePremium)}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>

            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Alimony, Child Support, Maintenance</Text>
                </Col>
                <Col className="subtital-typography">
                  {expensesDetails?.Aluminy_ChildSupport_Maintainance
                    ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.Aluminy_ChildSupport_Maintainance)}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>


            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Living Expenses</Text>
                </Col>
                <Col className="subtital-typography">
                  {expensesDetails?.LivingExpenses
                    ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.LivingExpenses)}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>


            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Other Expense</Text>
                </Col>
                <Col className="subtital-typography">
                  {expensesDetails?.OtherExpenses
                    ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.OtherExpenses)}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>

            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Total</Text>
                </Col>
                <Col className="subtital-typography">
                  {expensesDetails?.ExpenseTotal
                    ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.ExpenseTotal)}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>

          </Row>
        </div>
        {/* <ReviewCommentByApplicationIdAndSection  CommentSectionName="expenses" /> */}
      </Card>
      <Card
        title={

          <Row justify="space-between" align="middle">
            <Title className="initial-typography">
              <WalletOutlined />
              <span style={{ marginLeft: 8 }}>
                Balance Sheet - Assets (Liquid/Marketable Assets)
              </span>
            </Title>

            <Space>
              <span className="initial-typography">
                {financialStatementDataDetails.LiquidMarketableAssetsTotal
                  ? `$ ${_commonService.formatNumberWithCommas(
                    financialStatementDataDetails.LiquidMarketableAssetsTotal
                  )}`
                  : "N/A"}
              </span>

              <EditOutlined onClick={onBalanceSheetAssetsEditClick} />
            </Space>
          </Row>

        }

        className="mb10 mr5"
      >
        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseCashShortTermInvestmentChange}
        >
          <CollapsePanel
            key="1"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }} className="white-text">
                <Col>
                  <Text>Cash & Short-Term Investments</Text>
                </Col>
                <Col>
                  <Text>
                    {financialStatementDataDetails?.CashShortTermInvestmentsTotal
                      ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.CashShortTermInvestmentsTotal)}`
                      : "N/A"}
                  </Text>
                </Col>
              </Row>
            }
          >
            {cashShortTermInvestmentDetails?.map((item) => (
              <Card
                key={item.Id}
                size="small"
                type="inner"
                style={{ marginBottom: 16, borderRadius: 8 }}
                bodyStyle={{ padding: 16 }}
                className="pd cardViewMain"
              >
                <Row gutter={[16, 16]} >
                  <Col span={8}>
                    <Text type="secondary">Financial Institution :</Text>
                    <div className="value-text" >{item.FinInstitutionalName ? item.FinInstitutionalName : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Account Type :</Text>
                    <div className="value-text" >{item.TypeOfAccount ? item.TypeOfAccount : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Owner :</Text>
                    <div className="value-text">{item.Owner ? item.Owner : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Pledged To :</Text>
                    <div className="value-text">{item.PledgeToWhome ? item.PledgeToWhome : " N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Total Amount :</Text>
                    <div className="value-text">{item.Total ? `$${_commonService.formatNumberWithCommas(item.Total)}` : "N/A"}</div>
                  </Col>
                </Row>
              </Card>

            ))}
          </CollapsePanel>


        </Collapse>


        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseListedStockAndBondChange}
        >
          <CollapsePanel
            key="2"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }} className="white-text">
                <Col>
                  <Text >Listed Stocks and Bonds & Gov't Securities</Text>
                </Col>
                <Col>
                  <Text >{financialStatementDataDetails.StockBondGovSecurityTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.StockBondGovSecurityTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {listedStockAndBondsDetails?.map((item) => (
              <Card
                key={item.Id}
                size="small"
                type="inner"
                style={{ marginBottom: 16, borderRadius: 8 }}
                bodyStyle={{ padding: 16 }}
                className="pd cardViewMain"
              >
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <Text type="secondary">No. Shares or Par Value of Bonds, Notes, Bills :</Text>
                    <div className="value-text">{item.SharesOrParValueBonds_Notes_Bills ? `$ ${_commonService.formatNumberWithCommas(item.SharesOrParValueBonds_Notes_Bills)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Which Exchange :</Text>
                    <div className="value-text">{item.WhichExchage ? item.WhichExchage : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Description :</Text>
                    <div className="value-text">{item.Description ? item.Description : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Owner :</Text>
                    <div className="value-text">{item.Owner ? item.Owner : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Cost Basis :</Text>
                    <div className="value-text">{item.CoastBasis ? `$ ${_commonService.formatNumberWithCommas(item.CoastBasis)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Market Value :</Text>
                    <div className="value-text">{item.MarketValue ? `$ ${_commonService.formatNumberWithCommas(item.MarketValue)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">If Pledged, to whom? :</Text>
                    <div className="value-text">{item.PledgeToWhome ? item.PledgeToWhome : "N/A"}</div>
                  </Col>
                </Row>
              </Card>
            ))}
          </CollapsePanel>
        </Collapse>

        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseChangeAccountNotesReceivable}
        >
          <CollapsePanel
            key="3"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }} className="white-text">
                <Col>
                  <Text >Accounts and Notes Receivable</Text>
                </Col>
                <Col>
                  <Text >{financialStatementDataDetails?.AccountNoteReceivableTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.AccountNoteReceivableTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {accountsandNotesReceivableDetails?.map((item) => (
              <Card
                key={item.Id}
                size="small"
                type="inner"
                style={{ marginBottom: 16, borderRadius: 8 }}
                bodyStyle={{ padding: 16 }}
                className="pd cardViewMain"
              >
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <Text type="secondary">Name of Debtor :</Text>
                    <div className="value-text">{item.NameOfDebtor ? item.NameOfDebtor : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Collateral :</Text>
                    <div className="value-text">{item.Collateral ? ` ${_commonService.formatNumberWithCommas(item.Collateral)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Interest Rate :</Text>
                    <div className="value-text">{item.InterestRate ? ` ${_commonService.formatNumberWithCommas(item.InterestRate)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Payable :</Text>
                    <div className="value-text">{item.Payble ? `$ ${_commonService.formatNumberWithCommas(item.Payble)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Maturity Date :</Text>
                    <div className="value-text">{item.MaturityDate ? `${_commonService.formatDateWithSuffix(item.MaturityDate)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Unpaid Balance :</Text>
                    <div className="value-text">{item.UnpaidBalance ? `$ ${_commonService.formatNumberWithCommas(item.UnpaidBalance)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">If Pledged, to whom? :</Text>
                    <div className="value-text">{item.PledgeToWhome ? item.PledgeToWhome : "N/A"}</div>
                  </Col>
                </Row>
              </Card>
            ))}
          </CollapsePanel>
        </Collapse>

        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseCashValueLifeInsurance}
        >
          <CollapsePanel
            key="4"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }} className="white-text">
                <Col>
                  <Text >Cash Value (Net of Policy Loans) Life Insurance</Text>
                </Col>
                <Col>
                  <Text >{financialStatementDataDetails && financialStatementDataDetails.CashValueLifeInsuranceTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.CashValueLifeInsuranceTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {cashValueLifeInsuranceDetails?.map((item) => (
              <Card
                key={item.Id}
                size="small"
                type="inner"
                style={{ marginBottom: 16, borderRadius: 8 }}
                bodyStyle={{ padding: 16 }}
                className="pd cardViewMain"
              >
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <Text type="secondary">Name of Company :</Text>
                    <div className="value-text">{item.NameOfCompany ? item.NameOfCompany : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Beneficiary :</Text>
                    <div className="value-text">{item.Beneficiary ? item.Beneficiary : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Owner :</Text>
                    <div className="value-text">{item.Owner ? item.Owner : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Loans :</Text>
                    <div className="value-text">{item.Loans ? `$ ${_commonService.formatNumberWithCommas(item.Loans)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Cash Value :</Text>
                    <div className="value-text">{item.CashValue ? `$ ${_commonService.formatNumberWithCommas(item.CashValue)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Amount :</Text>
                    <div className="value-text">{item.Amount ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}` : "N/A"}</div>
                  </Col>
                </Row>
              </Card>
            ))}
          </CollapsePanel>
        </Collapse>
        <div className="alignment-padding">
          <Row gutter={[16, 0]}>
            {/* <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col><Text type="secondary">Category</Text></Col>
                <Col><Text type="secondary">Value</Text></Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Cash & Short-Term Investments</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.CashShortTermInvestmentsTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.CashShortTermInvestmentsTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">
                    Listed Stocks and Bonds & Gov&apos;t Securities
                  </Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.StockBondGovSecurityTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.StockBondGovSecurityTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Accounts and Notes Receivable</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.AccountNoteReceivableTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.AccountNoteReceivableTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">
                    Cash Value (Net of Policy Loans) Life Insurance
                  </Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.CashValueLifeInsuranceTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.CashValueLifeInsuranceTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col> */}
            <Col span={24} className="removeLeftPaddingColumn">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Other Liquid Assets</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.OtherLiquidAssetsTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.OtherLiquidAssetsTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
          </Row>
        </div>


        {/* <ReviewCommentByApplicationIdAndSection  CommentSectionName="balancesheetasset" /> */}
      </Card>
      <Card
        title={
          <Row justify="space-between" align="middle">
            <Title className="initial-typography">
              <TagsOutlined />
              <span style={{ marginLeft: 8 }}>
                Balance Sheet - Total Assets
              </span>
            </Title>

            <Space>
              <span className="initial-typography">
                {financialStatementDataDetails.AssetsTotal
                  ? `$ ${_commonService.formatNumberWithCommas(
                    financialStatementDataDetails.AssetsTotal
                  )}`
                  : "N/A"}
              </span>

              <EditOutlined onClick={onBalanceSheetTotalAssetsEditClick} />
            </Space>
          </Row>

        }

        className="mb10 mr5"
      >
        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseOwnPersonalResidence}
        >
          <CollapsePanel
            key="5"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }} className="white-text">
                <Col>
                  <Text >RE Owned - Personal Residence (S) - Total</Text>
                </Col>
                <Col>
                  <Text >{financialStatementDataDetails && financialStatementDataDetails.OwnPersonalResidenceTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.OwnPersonalResidenceTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {

              ownPersonalResidenceDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  style={{ marginBottom: 16, borderRadius: 8 }}
                  bodyStyle={{ padding: 16 }}
                  className="pd cardViewMain"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">Property & Location :</Text>
                      <div className="value-text">{item.PropertyAndLocation ? item.PropertyAndLocation : "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Owner :</Text>
                      <div className="value-text">{item.Owner ? item.Owner : "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Date Acquired :</Text>
                      <div className="value-text">{item.DateAcquired ? _commonService.formatDateWithSuffix(new Date(item.DateAcquired)) : "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Cost :</Text>
                      <div className="value-text">{item.Cost ? `$ ${_commonService.formatNumberWithCommas(item.Cost)}` : "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Market Value :</Text>
                      <div className="value-text">{item.MarketValue ? `$ ${_commonService.formatNumberWithCommas(item.MarketValue)}` : 'N/A'}</div>
                    </Col>

                    <Col span={8}>
                      <Text type="secondary">Mortgagor :</Text>
                      <div className="value-text">{item.Mortgagor || 'N/A'}</div>
                    </Col>

                    <Col span={8}>
                      <Text type="secondary">Maturity Date :</Text>
                      <div className="value-text">{item.Maturity ? _commonService.formatDateWithSuffix(item.Maturity) : 'N/A'}</div>
                    </Col>

                    <Col span={8}>
                      <Text type="secondary">Amount :</Text>
                      <div className="value-text">{item.Amount ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}` : 'N/A'}</div>
                    </Col>
                    <Col span={24}>
                      {item.Upload_Path ? (
                        <List.Item
                         className="listItemUploadPathCard"
                          actions={[
                            // <Button
                            //   icon={<EyeOutlined />}
                            //   type="text"
                            //   key="view"
                            //   onClick={() => onDocumentEyeClick({ name: 'Schedule of RE', url: item.Upload_Path })}
                            // />,
                            <Button
                              icon={<DownloadOutlined />}
                              type="text"
                              key="download"
                              onClick={() => onDocumentDownloadClick('Schedule of RE', item.Upload_Path)}
                            />,
                            <Button
                              disabled={!["1", "6"].includes(localStorage.getItem("ApplicationStatusId"))}
                              icon={
                                <DeleteOutlined
                                  className={!["1", "6"].includes(localStorage.getItem("ApplicationStatusId")) ? "iconDisabledColor" : ""}

                                />
                              }
                              type="text"
                              danger
                              key="delete"
                              onClick={() => deleteDocument({ name: 'Own Personal Residence', ownId: item.Id })}
                            />,
                          ]}
                        >
                          <Space size="middle">
                            <Text >Schedule of RE</Text>
                          </Space>
                        </List.Item>
                      ) : (
                        " "
                      )}
                    </Col>

                  </Row>
                </Card>
              ))
            }

            <Modal
              open={isModalVisible}
              title={selectedDocName}
              onCancel={() => setIsModalVisible(false)}
              footer={null}
              width="70vw"
              bodyStyle={{ height: '70vh', padding: 0 }}
              destroyOnClose
            >
              <iframe
                src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedDocUrl)}&embedded=true`}
                width="100%"
                height="100%"
                style={{ border: "none" }}
                title={selectedDocName}
              />
            </Modal>


          </CollapsePanel>
        </Collapse>

        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseestedIntrestPension}
        >
          <CollapsePanel
            key="6"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }} className="white-text">
                <Col>
                  <Text >Vested Interest in Pension/Profit Share/Deferred Comp</Text>
                </Col>
                <Col>
                  <Text >{financialStatementDataDetails.VestedIntrestPensionTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.VestedIntrestPensionTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              vestedIntrestPensionDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  style={{ marginBottom: 16, borderRadius: 8 }}
                  bodyStyle={{ padding: 16 }}
                  className="pd cardViewMain"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">Name of Company :</Text>
                      <div className="value-text">{item.NameOfCompany || 'N/A'}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Owner :</Text>
                      <div className="value-text">{item.Owner || 'N/A'}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Beneficiary :</Text>
                      <div className="value-text">{item.Beneficiary || 'N/A'}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Payout Basis :</Text>
                      <div className="value-text">${item.PayoutBasis ? _commonService.formatNumberWithCommas(item.PayoutBasis) : 'N/A'}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Date Available :</Text>
                      <div className="value-text">
                        {item.AvailableDate
                          ? _commonService.formatDateWithSuffix(item.AvailableDate)
                          : 'N/A'}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Amount :</Text>
                      <div className="value-text">
                        {item.Amount && item.Amount !== null && item.Amount !== undefined
                          ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}`
                          : 'N/A'}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            }

          </CollapsePanel>
        </Collapse>

        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapUnListedStocks}
        >
          <CollapsePanel
            key="7"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }} className="white-text">
                <Col>
                  <Text >Unlisted Stocks – Total Accounts and Notes Receivable</Text>
                </Col>
                <Col>
                  <Text >{financialStatementDataDetails.UnListedStocksTotal ? `$ ${financialStatementDataDetails && _commonService.formatNumberWithCommas(financialStatementDataDetails.UnListedStocksTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              unListedStocksDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  style={{ marginBottom: 16, borderRadius: 8 }}
                  bodyStyle={{ padding: 16 }}
                  className="pd cardViewMain"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">Description of Securities :</Text>
                      <div className="value-text">{item.DescriptionOfSecurity || 'N/A'}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">In Name Of, No. of Shares Owned:</Text>
                      <div className="value-text">
                        {item.InNameOf !== null && item.InNameOf !== undefined
                          ? _commonService.formatNumberWithCommas(item.InNameOf)
                          : 'N/A'}
                      </div>
                    </Col>

                    <Col span={8}>
                      <Text type="secondary">Ownership :</Text>
                      <div className="value-text">
                        {item.OwenershipPercentage
                          ? `${item.OwenershipPercentage} %`
                          : 'N/A'}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Book Value :</Text>
                      <div className="value-text">
                        {item.BookValue
                          ? `$ ${_commonService.formatNumberWithCommas(item.BookValue)}`
                          : 'N/A'}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Book Value Amount :</Text>
                      <div className="value-text">
                        {item.BookValueAmount
                          ? `$ ${_commonService.formatNumberWithCommas(item.BookValueAmount)}`
                          : 'N/A'}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">If Pledged, To Whom? :</Text>
                      <div className="value-text">{item.PledgeToWhome || 'N/A'}</div>
                    </Col>
                  </Row>
                </Card>
              ))
            }



          </CollapsePanel>
        </Collapse>
        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
           onChange={handleCollapeEquityInterestBusiness}
        >
          <Collapse.Panel
            key="99"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }} className="white-text">
                <Col>
                  <Text>Equity / Business Investment</Text>
                </Col>
                <Col>
                  <Text>
                    {financialStatementDataDetails.EquityInterestInBusinessTotal
                      ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.EquityInterestInBusinessTotal)}`
                      : "N/A"}
                  </Text>
                </Col>
              </Row>
            }
          >
            {equityIntrestBusinessDetails?.map((item) => (
              <Card
                key={item.Id}
                size="small"
                type="inner"
                style={{ marginBottom: 16, borderRadius: 8 }}
                bodyStyle={{ padding: 16 }}
                className="pd cardViewMain"
              >
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <Text type="secondary">Name of Company :</Text>
                    <div className="value-text">{item.NameOfCompany || "N/A"}</div>
                  </Col>

                  <Col span={8}>
                    <Text type="secondary">Ownership % :</Text>
                    <div className="value-text">
                      {item.OwnershipPercentage ? `${item.OwnershipPercentage}%` : "N/A"}
                    </div>
                  </Col>

                  <Col span={8}>
                    <Text type="secondary">Pledged To :</Text>
                    <div className="value-text">{item.IfPledgedtoWhom || "N/A"}</div>
                  </Col>

                  <Col span={8}>
                    <Text type="secondary">Valuation Firm :</Text>
                    <div className="value-text">{item.ValuationFirm || "N/A"}</div>
                  </Col>

                  <Col span={8}>
                    <Text type="secondary">Valuation Date :</Text>
                    <div className="value-text">
                      {item.ValuationDate
                        ? _commonService.formatDateWithSuffix(item.ValuationDate)
                        : "N/A"}
                    </div>
                  </Col>

                  <Col span={8}>
                    <Text type="secondary">Total Value :</Text>
                    <div className="value-text">
                      {item.Total && item.Total != null
                        ? `$ ${_commonService.formatNumberWithCommas(item.Total)}`
                        : "N/A"}
                    </div>
                  </Col>
                </Row>
              </Card>
            ))}
          </Collapse.Panel>
        </Collapse>


        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapReInvestment}
        >
          <CollapsePanel
            key="8"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }} className="white-text">
                <Col>
                  <Text >RE Investments</Text>
                </Col>
                <Col>
                  <Text >{financialStatementDataDetails.InvestmentTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.InvestmentTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              reInvestmentDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  style={{ marginBottom: 16, borderRadius: 8 }}
                  bodyStyle={{ padding: 16 }}
                  className="pd cardViewMain"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">Property & Location :</Text>
                      <div className="value-text">{item.PropertyAndLocation || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Owner :</Text>
                      <div className="value-text">{item.Owner || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Date Acquired :</Text>
                      <div className="value-text">{item.DateAcquired ? _commonService.formatDateWithSuffix(item.DateAcquired) : "N/A"}</div>
                    </Col>
                    {/* <Col span={8}>
                      <Text type="secondary">Cost :</Text>
                      <div className="value-text">
                        {item.Cost && item.Cost != null
                          ? `$ ${_commonService.formatNumberWithCommas(item.Cost)}`
                          : "N/A"}
                      </div>
                    </Col> */}
                    <Col span={8}>
                      <Text type="secondary">Market Value :</Text>
                      <div className="value-text">
                        {item.MarketValue && item.MarketValue != null
                          ? `$ ${_commonService.formatNumberWithCommas(item.MarketValue)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Mortgagor :</Text>
                      <div className="value-text">{item.Mortgagor || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Maturity Date :</Text>
                      <div className="value-text">{item.Maturity ? _commonService.formatDateWithSuffix(item.Maturity) : "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Amount :</Text>
                      <div className="value-text">
                        {item.Amount && item.Amount != null
                          ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}`
                          : "N/A"}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            }



          </CollapsePanel>
        </Collapse>

        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapgeneralAndLimitedPartenership}
        >
          <CollapsePanel
            key="9"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }} className="white-text">
                <Col>
                  <Text >General and/or Limited Partnership Interests</Text>
                </Col>
                <Col>
                  <Text >{financialStatementDataDetails.GeneralAndLimitedPartenershipIntrestTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.GeneralAndLimitedPartenershipIntrestTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              generalAndLimitedPartenershipDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  style={{ marginBottom: 16, borderRadius: 8 }}
                  bodyStyle={{ padding: 16 }}
                  className="pd cardViewMain"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">Name of Partnership :</Text>
                      <div className="value-text">{item.NameOfPartenership ? item.NameOfPartenership : "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Type of Investment :</Text>
                      <div className="value-text">{item.TypeOfInvestment ? item.TypeOfInvestment : "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Limited or General Partnership Interest :</Text>
                      <div className="value-text">{item.LimitedOrGeneral || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Amount Invested :</Text>
                      <div className="value-text">
                        {item.AmountInvested
                          ? `$ ${_commonService.formatNumberWithCommas(item.AmountInvested)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Fair Market Value of Partnership Interest :</Text>
                      <div className="value-text">
                        {item.FairMarketValue
                          ? `$ ${_commonService.formatNumberWithCommas(item.FairMarketValue)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={24}>
                      {item.Upload_Path ? (
                        <List.Item
                          className="listItemUploadPathCard"
                          actions={[
                            // <Button
                            //   icon={<EyeOutlined />}
                            //   type="text"
                            //   key="view"
                            //   onClick={() => onDocumentEyeClick({ name: 'Capital Account Statements', url: item.Upload_Path })}
                            // />,
                            <Button
                              icon={<DownloadOutlined />}
                              type="text"
                              key="download"
                              onClick={() => onDocumentDownloadClick('Capital Account Statements', item.Upload_Path)}
                            />,
                            <Button
                              disabled={!["1", "6"].includes(localStorage.getItem("ApplicationStatusId"))}
                              icon={
                                <DeleteOutlined
                                  className={!["1", "6"].includes(localStorage.getItem("ApplicationStatusId")) ? "iconDisabledColor" : ""}
                                />
                              }
                              type="text"
                              danger
                              key="delete"
                              onClick={() => deleteDocument({ name: 'General And Limited Partnership Interest', ownId: item.Id })}
                            />,
                          ]}
                        >
                          <Space size="middle">
                            <Text >Capital Account Statements</Text>
                          </Space>
                        </List.Item>
                      ) : (
                        " "
                      )}
                    </Col>
                  </Row>
                </Card>
              ))
            }
            <Modal
              open={isModalVisible}
              title={selectedDocName}
              onCancel={() => setIsModalVisible(false)}
              footer={null}
              width="70vw"
              bodyStyle={{ height: '70vh', padding: 0 }}
              destroyOnClose
            >
              <iframe
                src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedDocUrl)}&embedded=true`}
                width="100%"
                height="100%"
                style={{ border: "none" }}
                title={selectedDocName}
              />
            </Modal>
          </CollapsePanel>
        </Collapse>

        <div className="alignment-padding">
          <Row gutter={[16, 16]}>
            {/* <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col><Text type="secondary">Category</Text></Col>
                <Col><Text type="secondary">Value</Text></Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">
                    RE Owned - Personal Residence (S) - Total
                  </Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.OwnPersonalResidenceTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.OwnPersonalResidenceTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">
                    Vested Interest in Pension/Profit Share/Deferred Comp
                  </Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.VestedIntrestPensionTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.VestedIntrestPensionTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">
                    Unlisted Stocks – Total Accounts and Notes Receivable
                  </Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.UnListedStocksTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.UnListedStocksTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">RE Investments</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.InvestmentTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.InvestmentTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">
                    General and/or Limited Partnership Interests
                  </Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.GeneralAndLimitedPartenershipIntrestTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.GeneralAndLimitedPartenershipIntrestTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col> */}
            <Col span={24} className="removeLeftPaddingColumn">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">IRA/Keogh Accounts</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.IRAKeoghAccountsTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.IRAKeoghAccountsTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            {/* <Col span={24} className="removeLeftPaddingColumn">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Equity Interest in Business</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.EquityInterestInBusinessTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.EquityInterestInBusinessTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col> */}
            <Col span={24} className="removeLeftPaddingColumn">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Personal Property</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.PersonalPropertyTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.PersonalPropertyTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="removeLeftPaddingColumn">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Other Assets</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.OtherAssetsTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.OtherAssetsTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>

          </Row>
        </div>

        {/* <ReviewCommentByApplicationIdAndSection  CommentSectionName="balancesheettotalasset" /> */}
      </Card>

      <Card
        title={
          <Row justify="space-between" align="middle">
            <Title className="initial-typography">
              <ScheduleOutlined />
              <span style={{ marginLeft: 8 }}>
                Balance Sheet - Total Liabilities
              </span>
            </Title>

            <Space>
              <span className="initial-typography">
                {financialStatementDataDetails.LiabilitiesTotal
                  ? `$ ${_commonService.formatNumberWithCommas(
                    financialStatementDataDetails.LiabilitiesTotal
                  )}`
                  : "N/A"}
              </span>

              <EditOutlined onClick={onBalanceSheetTotalLiabilitiesAssetsEditClick} />
            </Space>
          </Row>
        }

        className="mb10 mr5"
      >
        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseNotesPayableBankSecured}
        >
          <CollapsePanel
            key="10"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }} className="white-text">
                <Col>
                  <Text >Notes Payable - Banks Secured</Text>
                </Col>
                <Col>
                  <Text >{financialStatementDataDetails.NotesPayableBankSecuredTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.NotesPayableBankSecuredTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              notesPayableBankSecuredDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  style={{ marginBottom: 16, borderRadius: 8 }}
                  bodyStyle={{ padding: 16 }}
                  className="pd cardViewMain"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">To Whom? :</Text>
                      <div className="value-text">{item.ToWhom || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Payment Amount :</Text>
                      <div className="value-text">
                        {item.PaymentAmount
                          ? `$ ${_commonService.formatNumberWithCommas(item.PaymentAmount)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Monthly/Quarterly/Semi-Annual/Annually :</Text>
                      <div className="value-text">{item.MonthlyQuaterlyAnnually || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Opening Date :</Text>
                      <div className="value-text">
                        {item.OpeningDate
                          ? _commonService.formatDateWithSuffix(item.OpeningDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Maturity Date :</Text>
                      <div className="value-text">
                        {item.MaturityDate
                          ? _commonService.formatDateWithSuffix(item.MaturityDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Description of Collateral :</Text>
                      <div className="value-text">{item.DescriptionOfCollateral || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Secured) :</Text>
                      <div className="value-text">
                        {item.Balance_Secured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_Secured)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Unsecured) :</Text>
                      <div className="value-text">
                        {item.Balance_UnSecured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_UnSecured)}`
                          : "N/A"}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            }

          </CollapsePanel>
        </Collapse>
        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseNotesPayableBankUnSecured}
        >
          <CollapsePanel
            key="11"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }} className="white-text">
                <Col>
                  <Text >Notes Payable - Banks Unsecured</Text>
                </Col>
                <Col>
                  <Text >{financialStatementDataDetails.NotesPayableBankUnSecuredTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.NotesPayableBankUnSecuredTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              notesPayableBankUnSecuredDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  style={{ marginBottom: 16, borderRadius: 8 }}
                  bodyStyle={{ padding: 16 }}
                  className="pd cardViewMain"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">To Whom? :</Text>
                      <div className="value-text">{item.ToWhom || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Payment Amount :</Text>
                      <div className="value-text">
                        {item.PaymentAmount
                          ? `$ ${_commonService.formatNumberWithCommas(item.PaymentAmount)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Monthly/Quarterly/Semi-Annual/Annually :</Text>
                      <div className="value-text">{item.MonthlyQuaterlyAnnually || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Opening Date :</Text>
                      <div className="value-text">
                        {item.OpeningDate
                          ? _commonService.formatDateWithSuffix(item.OpeningDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Maturity Date :</Text>
                      <div className="value-text">
                        {item.MaturityDate
                          ? _commonService.formatDateWithSuffix(item.MaturityDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Description of Collateral :</Text>
                      <div className="value-text">{item.DescriptionOfCollateral || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Secured) :</Text>
                      <div className="value-text">
                        {item.Balance_Secured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_Secured)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Unsecured) :</Text>
                      <div className="value-text">
                        {item.Balance_UnSecured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_UnSecured)}`
                          : "N/A"}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            }

          </CollapsePanel>
        </Collapse>

        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseChangeNotesPayableOther}
        >
          <CollapsePanel
            key="13"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }} className="white-text">
                <Col>
                  <Text >Notes Payable - Other</Text>
                </Col>
                <Col>
                  <Text >{financialStatementDataDetails.NotesPayableOtherTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.NotesPayableOtherTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              notesPayableOtherDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  style={{ marginBottom: 16, borderRadius: 8 }}
                  bodyStyle={{ padding: 16 }}
                  className="pd cardViewMain"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">To Whom? :</Text>
                      <div className="value-text">{item.ToWhom || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Payment Amount :</Text>
                      <div className="value-text">
                        {item.PaymentAmount
                          ? `$ ${_commonService.formatNumberWithCommas(item.PaymentAmount)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Monthly/Quarterly/Semi-Annual/Annually :</Text>
                      <div className="value-text">{item.MonthlyQuaterlyAnnually || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Opening Date :</Text>
                      <div className="value-text">
                        {item.OpeningDate
                          ? _commonService.formatDateWithSuffix(item.OpeningDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Maturity Date :</Text>
                      <div className="value-text">
                        {item.MaturityDate
                          ? _commonService.formatDateWithSuffix(item.MaturityDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Description of Collateral :</Text>
                      <div className="value-text">{item.DescriptionOfCollateral || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Secured) :</Text>
                      <div className="value-text">
                        {item.Balance_Secured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_Secured)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Unsecured) :</Text>
                      <div className="value-text">
                        {item.Balance_UnSecured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_UnSecured)}`
                          : "N/A"}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            }

          </CollapsePanel>
        </Collapse>

        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseAccountsPayableChange}
        >
          <CollapsePanel
            key="12"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }} className="white-text">
                <Col>
                  <Text >Accounts Payable</Text>
                </Col>
                <Col>
                  <Text >{financialStatementDataDetails && financialStatementDataDetails.AccountsPayableTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.AccountsPayableTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              accountPayableDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  style={{ marginBottom: 16, borderRadius: 8 }}
                  bodyStyle={{ padding: 16 }}
                  className="pd cardViewMain"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">To Whom? :</Text>
                      <div className="value-text">{item.ToWhom || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Payment Amount :</Text>
                      <div className="value-text">
                        {item.PaymentAmount
                          ? `$ ${_commonService.formatNumberWithCommas(item.PaymentAmount)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Monthly/Quarterly/Semi-Annual/Annually :</Text>
                      <div className="value-text">{item.MonthlyQuaterlyAnnually || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Opening Date :</Text>
                      <div className="value-text">
                        {item.OpeningDate
                          ? _commonService.formatDateWithSuffix(item.OpeningDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Maturity Date :</Text>
                      <div className="value-text">
                        {item.MaturityDate
                          ? _commonService.formatDateWithSuffix(item.MaturityDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Description of Collateral :</Text>
                      <div className="value-text">{item.DescriptionOfCollateral || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Secured) :</Text>
                      <div className="value-text">
                        {item.Balance_Secured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_Secured)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Unsecured) :</Text>
                      <div className="value-text">
                        {item.Balance_UnSecured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_UnSecured)}`
                          : "N/A"}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            }

          </CollapsePanel>
        </Collapse>

        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseChangeCreditCardsBalance}
        >
          <CollapsePanel
            key="14"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }} className="white-text">
                <Col>
                  <Text >Credit Card Balances</Text>
                </Col>
                <Col>
                  <Text >{financialStatementDataDetails.CreditCardsBalancesTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.CreditCardsBalancesTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              creditCardBalanceDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  style={{ marginBottom: 16, borderRadius: 8 }}
                  bodyStyle={{ padding: 16 }}
                  className="pd cardViewMain"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">To Whom? :</Text>
                      <div className="value-text">{item.ToWhom || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Payment Amount :</Text>
                      <div className="value-text">
                        {item.PaymentAmount
                          ? `$ ${_commonService.formatNumberWithCommas(item.PaymentAmount)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Monthly/Quarterly/Semi-Annual/Annually :</Text>
                      <div className="value-text">{item.MonthlyQuaterlyAnnually || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Opening Date :</Text>
                      <div className="value-text">
                        {item.OpeningDate
                          ? _commonService.formatDateWithSuffix(item.OpeningDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Maturity Date :</Text>
                      <div className="value-text">
                        {item.MaturityDate
                          ? _commonService.formatDateWithSuffix(item.MaturityDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Description of Collateral :</Text>
                      <div className="value-text">{item.DescriptionOfCollateral || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Secured) :</Text>
                      <div className="value-text">
                        {item.Balance_Secured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_Secured)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Unsecured) :</Text>
                      <div className="value-text">
                        {item.Balance_UnSecured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_UnSecured)}`
                          : "N/A"}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            }

          </CollapsePanel>
        </Collapse>


        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseChangeMortagagesDueWihtinOne}
        >
          <CollapsePanel
            key="15"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }} className="white-text">
                <Col>
                  <Text >Mortgages Due Within 1 Year</Text>
                </Col>
                <Col>
                  <Text >{financialStatementDataDetails.MortgagesDueWithinOneYearTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.MortgagesDueWithinOneYearTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              mortgagesDueWithInOneDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  style={{ marginBottom: 16, borderRadius: 8 }}
                  bodyStyle={{ padding: 16 }}
                  className="pd cardViewMain"
                >
                  <Row gutter={[16, 16]} >
                    <Col span={8}>
                      <Text type="secondary">Property & Location :</Text>
                      <div className="value-text">{item.PropertyAndLocation || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Owner :</Text>
                      <div className="value-text">{item.Owner || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Date Acquired :</Text>
                      <div className="value-text">
                        {item.DateAcquired
                          ? _commonService.formatDateWithSuffix(item.DateAcquired)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Cost :</Text>
                      <div className="value-text">
                        {item.Cost
                          ? `$ ${_commonService.formatNumberWithCommas(item.Cost)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Market Value :</Text>
                      <div className="value-text">
                        {item.MarketValue
                          ? `$ ${_commonService.formatNumberWithCommas(item.MarketValue)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Mortgagor :</Text>
                      <div className="value-text">{item.Mortgagor || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Maturity Date :</Text>
                      <div className="value-text">
                        {item.Maturity
                          ? _commonService.formatDateWithSuffix(item.Maturity)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Amount :</Text>
                      <div className="value-text">
                        {item.Amount
                          ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={24}>
                      {item.Upload_Path ? (
                        <List.Item
                          className="listItemUploadPathCard"
                          actions={[
                            // <Button
                            //   icon={<EyeOutlined />}
                            //   type="text"
                            //   key="view"
                            //   onClick={() => onDocumentEyeClick({ name: 'Schedule of RE', url: item.Upload_Path })}
                            // />,
                            <Button
                              icon={<DownloadOutlined />}
                              type="text"
                              key="download"
                              onClick={() => onDocumentDownloadClick('Schedule of RE', item.Upload_Path)}
                            />,
                            <Button
                              disabled={!["1", "6"].includes(localStorage.getItem("ApplicationStatusId"))}
                              icon={
                                <DeleteOutlined
                                  className={!["1", "6"].includes(localStorage.getItem("ApplicationStatusId")) ? "iconDisabledColor" : ""}
                                />
                              }
                              type="text"
                              danger
                              key="delete"
                              onClick={() => deleteDocument({ name: 'Mortgage Due Within', ownId: item.Id })}
                            />,
                          ]}
                        >
                          <Space size="middle">
                            <Text >Schedule of RE</Text>
                          </Space>
                        </List.Item>
                      ) : (
                        " "
                      )}
                    </Col>

                  </Row>
                </Card>
              ))
            }
            <Modal
              open={isModalVisible}
              title={selectedDocName}
              onCancel={() => setIsModalVisible(false)}
              footer={null}
              width="70vw"
              bodyStyle={{ height: '70vh', padding: 0 }}
              destroyOnClose
            >
              <iframe
                src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedDocUrl)}&embedded=true`}
                width="100%"
                height="100%"
                style={{ border: "none" }}
                title={selectedDocName}
              />
            </Modal>


          </CollapsePanel>
        </Collapse>


        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseChangeMortagagesDueBeyondOne}
        >
          <CollapsePanel
            key="16"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }} className="white-text">
                <Col>
                  <Text >Mortgages Due Beyond 1 Year</Text>
                </Col>
                <Col>
                  <Text >{financialStatementDataDetails.MortgagesDueBeyondOneYearTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.MortgagesDueBeyondOneYearTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              mortgagesDueBeyondOneDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  style={{ marginBottom: 16, borderRadius: 8 }}
                  bodyStyle={{ padding: 16 }}
                  className="pd cardViewMain"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">Property & Location :</Text>
                      <div className="value-text">{item.PropertyAndLocation || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Owner :</Text>
                      <div className="value-text">{item.Owner || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Date Acquired :</Text>
                      <div className="value-text">
                        {item.DateAcquired
                          ? _commonService.formatDateWithSuffix(item.DateAcquired)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Cost :</Text>
                      <div className="value-text">
                        {item.Cost
                          ? `$ ${_commonService.formatNumberWithCommas(item.Cost)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Market Value :</Text>
                      <div className="value-text">
                        {item.MarketValue
                          ? `$ ${_commonService.formatNumberWithCommas(item.MarketValue)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Mortgagor :</Text>
                      <div className="value-text">{item.Mortgagor || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Maturity Date :</Text>
                      <div className="value-text">
                        {item.Maturity
                          ? _commonService.formatDateWithSuffix(item.Maturity)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Amount :</Text>
                      <div className="value-text">
                        {item.Amount
                          ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={24}>
                      {item.Upload_Path ? (
                        <List.Item
                          className="listItemUploadPathCard"
                          actions={[
                            // <Button
                            //   icon={<EyeOutlined />}
                            //   type="text"
                            //   key="view"
                            //   onClick={() => onDocumentEyeClick({ name: 'Schedule of RE', url: item.Upload_Path })}
                            // />,
                            <Button
                              icon={<DownloadOutlined />}
                              type="text"
                              key="download"
                              onClick={() => onDocumentDownloadClick('Schedule of RE', item.Upload_Path)}
                            />,
                            <Button
                              disabled={!["1", "6"].includes(localStorage.getItem("ApplicationStatusId"))}
                              icon={
                                <DeleteOutlined
                                  className={!["1", "6"].includes(localStorage.getItem("ApplicationStatusId")) ? "iconDisabledColor" : ""}

                                />
                              }
                              type="text"
                              danger
                              key="delete"
                              onClick={() => deleteDocument({ name: 'Mortgage Due Beyond', ownId: item.Id })}
                            />,
                          ]}
                        >
                          <Space size="middle">
                            <Text >Schedule of RE</Text>
                          </Space>
                        </List.Item>
                      ) : (
                        " "
                      )}
                    </Col>
                  </Row>
                </Card>
              ))
            }

            <Modal
              open={isModalVisible}
              title={selectedDocName}
              onCancel={() => setIsModalVisible(false)}
              footer={null}
              width="70vw"
              bodyStyle={{ height: '70vh', padding: 0 }}
              destroyOnClose
            >
              <iframe
                src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedDocUrl)}&embedded=true`}
                width="100%"
                height="100%"
                style={{ border: "none" }}
                title={selectedDocName}
              />
            </Modal>

          </CollapsePanel>
        </Collapse>

        <div className="alignment-padding">
          <Row gutter={[16, 16]}>
            {/* <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col><Text type="secondary">Category</Text></Col>
                <Col><Text type="secondary">Value</Text></Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Notes Payable - Banks Secured</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.NotesPayableBankSecuredTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.NotesPayableBankSecuredTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Notes Payable - Banks Unsecured</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.NotesPayableBankUnSecuredTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.NotesPayableBankUnSecuredTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Notes Payable - Other</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.NotesPayableOtherTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.NotesPayableOtherTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Accounts Payable</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.AccountsPayableTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.AccountsPayableTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Credit Card Balances</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.CreditCardsBalancesTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.CreditCardsBalancesTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Mortgages Due Within 1 Year</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.MortgagesDueWithinOneYearTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.MortgagesDueWithinOneYearTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="b-bottm">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Mortgages Due Beyond 1 Year</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.MortgagesDueBeyondOneYearTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.MortgagesDueBeyondOneYearTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col> */}
            <Col span={24} className="removeLeftPaddingColumn">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Unpaid Income Taxes</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.UnpaidIncomeTaxesTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.UnpaidIncomeTaxesTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="removeLeftPaddingColumn">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Margin Accounts</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.MarginAccountTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.MarginAccountTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>

            <Col span={24} className="removeLeftPaddingColumn">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Other Liabilities</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.OtherLiabilitiesTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.OtherLiabilitiesTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>
            <Col span={24} className="removeLeftPaddingColumn">
              <Row justify="space-between" align="middle">
                <Col className="subtital-typography">
                  <Text type="secondary">Net Worth</Text>
                </Col>
                <Col className="subtital-typography">
                  {financialStatementDataDetails.NetWorthTotal
                    ? `$ ${_commonService.formatNumberWithCommas(
                      financialStatementDataDetails.NetWorthTotal
                    )}`
                    : "N/A"}
                </Col>
              </Row>
            </Col>

          </Row>
        </div>












        {/* <div class="ant-row ant-row-space-between ant-row-middle" style={{ padding: "12px 16px" }}>
          <div class="ant-col">
            <span class="ant-typography">Total Liabilities</span>
          </div>
          <div class="ant-col">
            <span class="ant-typography">{financialStatementDataDetails.LiabilitiesTotal}</span>
          </div>
        </div> */}


        {/* <ReviewCommentByApplicationIdAndSection  CommentSectionName="balancesheetliability" /> */}
      </Card>

      <BalanceSheetQuestionnaireConsumerDashboard activeKey={activeKey} />

    </Spin>
  )
}
export default FinancialStatementTabForConsumer;